import {stringToFriendlyDatetime} from "../helpers/datetime-helpers";


export default function activityParams(item) {
    switch (item.type) {
        default :
            return modelActivity(item)
    }
}

function modelActivity(item) {
    return {
        message: formatType(item),
        body : getActivityBody(item),
        created_by : item.user.name,
        created_at : stringToFriendlyDatetime(item.created_at),
        link: getActionLink(item)
    };
}

 function getActionLink(item) {
    switch (item.type) {
        case ('company_updated') :
            return `/myeb/account`;
    }
}

function formatType(item) {
    return item.type.split('_').join(' ')
}

function getActivityBody(item) {
    switch (item.type) {
        case ('company_updated') :
            return `${item.meta.name} details has been updated`
    }
}
